import { Container, Typography } from '@material-ui/core';
import React from 'react';
import DatosFormularioView from './DatosFormularioView';
import Pasos from './Pasos';

const FormDataView = props => {
  const { baseObject, eventos, isPhone } = props;

  return (
    <Container maxWidth="lg">
      <Typography variant="h5" gutterBottom>
        Resumen de la solicitud
      </Typography>
      <DatosFormularioView
        values={baseObject}
        eventos={eventos}
        isPhone={isPhone}
      />
      <Typography variant="h5" gutterBottom>
        Datos cargados en la solicitud
      </Typography>
      <Pasos
        {...{
          isPhone,
          baseObject
        }}
      />
    </Container>
  );
};

export default FormDataView;
